import { PlusOutlined } from '@ant-design/icons'
import { requestUpdateLocationActivity } from 'app/api/location'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputNumber } from 'app/components/common/inputs/InputNumber'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { ILocation } from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { notificationController } from 'app/controllers/notification-controller'
import { extractCoordinates } from 'app/hook'
import { getRandomUuid } from 'parkway-web-common'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

export const ModalUpdateLocation = ({ location }: { location: ILocation }) => {
  const [form] = BaseForm.useForm<ILocation>()
  const modalRef = useRef<IRefModal>({})
  const [loading, setLoading] = useState(false)

  const openModal = () => {
    modalRef?.current?.open?.()
  }

  const handleSubmit = async (values: ILocation) => {
    if (!location?.id) return
    try {
      setLoading(true)
      const { latitude, longitude } = extractCoordinates(values?.coordinates)
      const res = await requestUpdateLocationActivity({
        address: values?.address,
        lat: latitude,
        long: longitude,
        radius: values?.radius,
        key_map_check_in: getRandomUuid(),
        id: location?.id,
      })
      if (res) {
        modalRef?.current?.hide?.()
        notificationController.success({ message: 'Thành công!' })
        window.location.reload()
        form?.resetFields?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      address: location?.address,
      coordinates: `${location?.lat}, ${location?.long}`,
      radius: location?.radius,
    })
  }, [location])
  return (
    <BaseModalComponent
      titleModal={'Cập nhật địa điểm'}
      handleSubmit={form?.submit}
      ref={modalRef}
      isLoadingConfirm={loading}
      buttonOpenModal={
        <BaseButton type='text' icon={<PlusOutlined rev={undefined} />} onClick={openModal}>
          {'Cập nhật'}
        </BaseButton>
      }
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseForm.Item
            label={'Địa chỉ'}
            name={'address'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập địa chỉ',
              },
            ]}
          >
            <BaseInput placeholder="Nhập địa chỉ" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Toạ độ'}
            name={'coordinates'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập toạ độ',
              },
            ]}
          >
            <BaseInput placeholder="Nhập toạ độ checkin từ google map" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Bán kính (m)'}
            name={'radius'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập bán kính',
              },
            ]}
            initialValue={1}
          >
            <InputNumberWrapper min={1} placeholder="Nhập bán kính" />
          </BaseForm.Item>
        </BaseForm>
      }
    />
  )
}

const InputNumberWrapper = styled(InputNumber)`
  width: 100%;
`
